const COOKIE_CONSENT_KEY = 'cookie_consent';

export type ConsentStatus = 'granted' | 'denied' | 'unset';

export const getConsentStatus = (): ConsentStatus => {
  const stored = localStorage.getItem(COOKIE_CONSENT_KEY);
  if (stored === 'granted' || stored === 'denied') return stored;
  return 'unset';
};

export const setConsentStatus = (status: ConsentStatus) => {
  localStorage.setItem(COOKIE_CONSENT_KEY, status);

  if (status === 'granted') {
    window.location.reload(); // Reload to allow the script to be included from <head>
  }
};

export const clearConsentStatus = () => {
  localStorage.removeItem(COOKIE_CONSENT_KEY);
};
